export default () => {

  const s = {};
  s.targetSelector = 'char-slide';
  s.wHeightThreshold = .8;
  const build = (ele) => {
    return new Promise(resolve => {
      s.resolver = resolve;
      s.title = ele.querySelector(`.js-${s.targetSelector}`);
      if (!s.title) {
        s.resolver();
        return;
      }

      titleInit(s.title);
      bindScrollBoot();
    })
  }

  const titleInit = (title) => {
    title.classList.add(s.targetSelector);
    const titleStr = popTextContent(title);
    title.setAttribute('aria-label', titleStr);
    const titleInnerEle = createTitleInnerEle();
    titleInnerEle.innerHTML = createTitleCharsEle(titleStr);
    title.appendChild(titleInnerEle);
  }
  const popTextContent = (ele) => {
    const popText = ele.textContent;
    ele.textContent = '';
    return popText;
  }
  const createTitleInnerEle = () => {
    const titleInnerEle = document.createElement('div');
    titleInnerEle.classList.add(`${s.targetSelector}__inner`);
    titleInnerEle.style.overflow = 'hidden';

    return titleInnerEle;
  }
  const createTitleCharsEle = (text) => {
    return [].map.call(text, (char, idx) => `<span class="${s.targetSelector}__char" style="transition-delay: ${idx * .05}s">${char}</span>`).join('');
  }

  const bindScrollBoot = () => {
    s.wInnerHeight = window.innerHeight;
    window.addEventListener('scroll', scrollAction, false);
    scrollAction();
  }
  const scrollAction = () => {
    if (getTitleTopPos() < (s.wInnerHeight * s.wHeightThreshold)) {
      s.title.classList.add('is-visibled');
      window.removeEventListener('scroll', scrollAction, false);
      bootAnimationResolver();
    }
  }
  const getTitleTopPos = () => {
    return s.title.getBoundingClientRect().top;
  }
  const bootAnimationResolver = () => {
    const chars = s.title.querySelectorAll(`.${s.targetSelector}__char`);
    const bootPos = Math.floor(chars.length * (2/3)) | 0;
    chars[bootPos].addEventListener('transitionend', () => {
      s.resolver();
    })
  }

  return {
    build
  }
}
